import React from 'react';
import { createBrowserRouter } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import Dashboard from './pages/Dashboard';
import Quotations from './pages/Quotations';
import SystemAdmin from './pages/admin/SystemAdmin';
import NotFound from './pages/NotFound';
import Login from './pages/Login';
import ProtectedRoute from './components/routing/ProtectedRoute';
import Customers from './pages/Customers';
import CustomerRelationshipLogs from './pages/CustomerRelationshipLogs';
import Products from './pages/Products';
import Settings from './pages/Settings';
import Deals from './pages/Deals';
import Users from 'pages/admin/Users';
import ActivityLogs from 'pages/admin/ActivityLogs';
import Organizations from 'pages/admin/Organizations';
import Contracts from 'pages/Contracts';
import { ProfilePage } from './components/profile/ProfilePage';
import SharedContractView from './pages/SharedContractView';
import SharedQuotationView from './pages/SharedQuotationView';
import Templates from 'pages/Templates';
import DocxToPdfTest from './pages/DocxToPdfTest';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import { Navigate } from 'react-router-dom';
import EnergiaPODs from './pages/EnergiaPODs';
import EnergiaBilling from './pages/EnergiaBilling';
import EnergiaDashboard from './pages/EnergiaDashboard';
import EnergiaAnalytics from './pages/EnergiaAnalytics';
import EnergiaMonitoring from './pages/EnergiaMonitoring';
import EnergiaUTILMD from './pages/EnergiaUTILMD';
import EnergiaContracts from './pages/EnergiaContracts';
import ConsumptionLocations from './pages/ConsumptionLocations';
import DocumentStorage from './pages/DocumentStorage';
import MsconsReadings from './pages/MsconsReadings';
import EnergiaProducts from './pages/EnergiaProducts';
import BulkInvoiceManager from './pages/BulkInvoiceManager';
import InvoiceAttachments from './pages/InvoiceAttachments';
import DownloadPage from './pages/DownloadPage';
import HupxBrowser from './pages/HupxBrowser';
import Consultants from './pages/Consultants';
import GasDashboard from './pages/GasDashboard';
import GasPods from './pages/GasPods';
import GasContracts from './pages/GasContracts';
import GasReadings from './pages/GasReadings';
import GasInvoices from './pages/GasInvoices';
import GasNominations from './pages/GasNominations';

export const router = createBrowserRouter([
  // Public routes
  {
    path: '/login',
    element: <Login />
  },
  {
    path: '/terms-of-service',
    element: <TermsOfService />
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicy />
  },
  {
    path: '/quotations/public/:quotationId',
    element: <SharedQuotationView />
  },
  {
    path: '/shared/contracts/:contractId',
    element: <SharedContractView />
  },
  {
    path: '/download/:token',
    element: <DownloadPage />
  },
  // Protected routes
  {
    path: '/',
    element: <ProtectedRoute><MainLayout /></ProtectedRoute>,
    children: [
      {
        index: true,
        element: <Navigate to="/dashboard" replace />
      },
      {
        path: 'dashboard',
        element: <Dashboard />
      },
      {
        path: 'customers',
        element: <Customers />
      },
      {
        path: 'quotations',
        element: <Quotations />
      },
      {
        path: 'deals',
        element: <Deals />
      },
      {
        path: 'customer-relationship-logs',
        element: <CustomerRelationshipLogs />
      },
      {
        path: 'products',
        element: <Products />
      },
      {
        path: 'contracts',
        element: <Contracts />
      },
      {
        path: 'consultants',
        element: <Consultants />
      },
      {
        path: 'energia-dashboard',
        element: <EnergiaDashboard />
      },
      {
        path: 'energia-pods',
        element: <EnergiaPODs />
      },
      {
        path: 'energia-contracts',
        element: <EnergiaContracts />
      },
      {
        path: 'energia-products',
        element: <EnergiaProducts />
      },
      {
        path: 'bulk-invoice-manager',
        element: <BulkInvoiceManager />
      },
      {
        path: 'invoice-attachments',
        element: <InvoiceAttachments />
      },
      {
        path: 'hupx-browser',
        element: <HupxBrowser />
      },
      {
        path: 'energia-billing',
        element: <EnergiaBilling />
      },
      {
        path: 'energia-analytics',
        element: <EnergiaAnalytics />
      },
      {
        path: 'energia-monitoring',
        element: <EnergiaMonitoring />
      },
      {
        path: 'gas-dashboard',
        element: <GasDashboard />
      },
      {
        path: 'gas-pods',
        element: <GasPods />
      },
      {
        path: 'gas-contracts',
        element: <GasContracts />
      },
      {
        path: 'gas-readings',
        element: <GasReadings />
      },
      {
        path: 'gas-invoices',
        element: <GasInvoices />
      },
      {
        path: 'gas-nominations',
        element: <GasNominations />
      },
      {
        path: 'energia-utilmd',
        element: <EnergiaUTILMD />
      },
      {
        path: 'mscons-readings',
        element: <MsconsReadings />
      },
      {
        path: 'consumption-locations',
        element: <ConsumptionLocations />
      },
      {
        path: 'settings',
        element: <Settings />
      },
      {
        path: 'profile',
        element: <ProfilePage />
      },
      {
        path: 'system-admin',
        element: <SystemAdmin />
      },
      {
        path: 'system-admin/users',
        element: <Users />
      },
      {
        path: 'system-admin/activity-logs',
        element: <ProtectedRoute allowedRoles={['super_admin']}><ActivityLogs /></ProtectedRoute>
      },
      {
        path: 'system-admin/organizations',
        element: <Organizations />
      },
      {
        path: 'templates',
        element: <Templates />
      },
      {
        path: 'document-storage',
        element: <DocumentStorage />
      },
      {
        path: 'docx-to-pdf-test',
        element: <DocxToPdfTest />
      },
      {
        path: '*',
        element: <NotFound />
      }
    ]
  }
]); 